const MetaTrader4ContentFour = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <div className="content-left">
                <h2>What You Can Trade on MetaTrader 4</h2>

                <p>
                  Access a wide range of instruments and trade across major
                  global markets, all in one platform.
                </p>
              </div>
              <img
                src={process.env.PUBLIC_URL + "/images/platforms/meta_trader_4/meta_trader_4_03.png"}
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h3>Forex</h3>
              <p>
                Trade major, minor, and exotic currency pairs with low spreads
                and high liquidity. Analyze movements, manage risks, and
                capitalize on global economic trends.
                {/* Conversely, rate cuts can weaken a
                currency as investors seek higher yields elsewhere. Traders
                closely follow central bank announcements and policy statements
                to anticipate shifts in monetary policy. */}
              </p>
              <hr className="black-line" />
              <h3> Commodities</h3>
              <p>
                Diversify your portfolio with gold, oil, and other key
                commodities. MT4 provides accurate price tracking and execution
                for stable, leveraged trading.
                {/* Stable inflation and strong
                performance usually strengthen a currency, while economic
                slowdown or uncertainty can cause depreciation. Traders monitor
                key indicators like CPI, PMI, and retail sales to identify
                potential trends in currency valuation. */}
              </p>
              <hr className="black-line" />
              <h3>Cryptocurrencies</h3>
              <p>
                Explore the crypto market with pairs like BTC/USD and ETH/USD.
                Benefit from secure order execution and real-time market
                insights with The Pips’ enhanced MT4 environment.
                {/* In contrast, geopolitical
                tensions or unexpected global events can increase volatility as
                traders move toward safe-haven assets like the USD, CHF, or JPY. */}
              </p>
              <hr className="black-line" />
              <h3>Stocks</h3>
              <p>
                Trade global equities directly from your MT4 dashboard. Access
                real-time quotes, track performance, and take advantage of
                market movements from the world’s biggest companies.
                {/* Large institutional players and algorithmic trading
                systems can amplify these effects, making sentiment analysis a
                valuable tool for modern forex traders. */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader4ContentFour;
